import { Component, inject } from '@angular/core';
import { CustomButtonComponent } from '@app/components/_ui/custom-button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'custom-dialog-close-icon',
    template: `
        <custom-button
            class="flex items-end justify-center"
            icon="close"
            type="grey"
            iconOnly
            (click)="ref.close()" />
    `,
    styles: `
        :host {
        }
    `,

    imports: [CustomButtonComponent],
})
export class CustomDialogCloseIconComponent {
    protected readonly ref = inject(DynamicDialogRef);
}
